import React, { useState, useEffect, useMemo } from 'react'
import ReactDataTableBootstrap from '../../Components/ReactDataTableBootstrap/ReactDataTableBootstrap';
import Controllers from '../../Api/Controllers';
import { toast } from 'react-toastify';
import Helpers from '../../Components/Helpers/Helpers';
import { Link } from 'react-router-dom';
import SweetAlert from '../../Components/SweetAlert/SweetAlert';
import { ActionIconButton, ListPageShell, EmptyState } from '../../Components/Ui'

const ArticleList = ({ nameSingle, separator, namePlural }) => {
    const [isProcessing, setIsProccesing] = useState(true)
    const [reload, setReload] = useState(true);
    const [rows, setRows] = useState([])
    const [localSearch, setLocalSearch] = useState('')
    const [tableFilter, setTableFilter] = useState('')

    useEffect(() => {
        if (reload) {
            setIsProccesing(true)
            Controllers.article.get_article({
                p_paginate: ''
            }).then(res => {
                setRows(res.data)
            }).catch(req => Helpers.promise.catch({ req, toast }))
            .finally(() => {
                setIsProccesing(false)
                setReload(false)
            })
        }
    }, [reload])

    const [dataDeleted, setDataDeleted] = useState({})
    const [loadSubmitDelete, setLoadSubmitDelete] = useState(false)
    const [showConfirmDelete, setShowConfirmDelete] = useState(false)

    const handleDelete = () => {
        setLoadSubmitDelete(true)

        Controllers.article.article_delete(dataDeleted).then(res => {
            Helpers.toast.construct({ ...res, toast })
            if (res.response === 'success') {
                setShowConfirmDelete(false)
                setDataDeleted({})
            }
        }).catch(req => Helpers.promise.catch({ req, toast }))
        .finally(() => {
            setReload(true)
            setLoadSubmitDelete(false)
        })
    }

    const handleShowModalDelete = e => {
        let { idArticle, nameArticle } = e.currentTarget.dataset
        setDataDeleted({
            p_id_article: idArticle,
            p_name_article: nameArticle
        })
        setShowConfirmDelete(true)
    }

    const handleHideModalDelete = () => setShowConfirmDelete(false)

    const applySearch = () => setTableFilter(localSearch)

    const dtRows = useMemo(() => <ReactDataTableBootstrap
        textFilter={tableFilter}
        hideSearch
        head={[
            [
                { name: 'id_article', text: 'ID', align: 'center' },
                { name: 'name_article', text: 'Nombres' },
                { name: 'file_images', text: 'Imagen', render: r => <img className="img-thumbnail" width="100" src={Helpers.config.resourcesUrl({ url: r.file_images })} />, align: 'center' },
                { name: 'name_category', text: 'Departamento' },
                { name: 'actions', text: 'Acciones', align: 'center', render: u => {
                    return <div className="sp-row-actions">
                        <Link to={Helpers.config.convertUrl({ url: '/blog/' + u.token_article })}>
                            <ActionIconButton tone="ghost" icon="fas fa-link" label="Ver" />
                        </Link>
                        <ActionIconButton tone="danger" icon="fa fa-trash" label="Eliminar" data-id-article={u.id_article} onClick={handleShowModalDelete} data-name-article={u.name_article} />
                    </div>
                } },
            ],
        ]}
        rows={rows}
        isProcessing={isProcessing}
    />, [rows, isProcessing, tableFilter])

    const showEmpty = !isProcessing && rows.length === 0

    return <>
        <ListPageShell
            eyebrow="Super Papelera — Espacio de trabajo"
            title={`Listado de ${namePlural}`}
            subtitle="Consulta y administra las entradas del blog desde un solo lugar."
            badge="Actividad actualizada"
            onSearch={applySearch}
            filters={[
                {
                    label: 'Buscar',
                    control: (
                        <input
                            type="search"
                            placeholder="Título, departamento…"
                            value={localSearch}
                            onChange={e => setLocalSearch(e.target.value)}
                            onKeyDown={e => { if (e.key === 'Enter') applySearch() }}
                        />
                    )
                }
            ]}
        >
            {showEmpty ? (
                <EmptyState
                    icon="fa fa-newspaper"
                    title={`No hay ${namePlural.toLowerCase()} para mostrar`}
                    text="Ajusta la búsqueda o publica una nueva entrada para empezar."
                />
            ) : (
                <div className="sp-table-wrap">{dtRows}</div>
            )}
        </ListPageShell>
        <SweetAlert
            icon="delete"
            show={showConfirmDelete}
            showCancelButton
            title={<>¿Desea eliminar {separator} {nameSingle}?</>}
            subtitle={<>#{dataDeleted.p_id_article} - {dataDeleted.p_name_article}</>}
            confirmButtonText="¡Sí, eliminar!"
            cancelButtonText="¡No!"
            loadSubmit={loadSubmitDelete}
            onCancel={handleHideModalDelete}
            onConfirm={handleDelete}
        />
    </>
}

export default ArticleList
